// extracted by mini-css-extract-plugin
export default {"fab":"styles_fab__bUglz","fab-danger":"styles_fab-danger__Uy2qm"};